export default "__VITE_ASSET__COkA6eEH__"